import NavigationBar from "../../navigation/nav-bar/navigationBar";
import FooterComponent from "../../navigation/footer/footerComponent";
import NextBigThingBodyComponent from "./nextBigThingBodyComponent";


export default function MainNextBigThing() {

    return (
        <div>
            <NavigationBar />
            <NextBigThingBodyComponent />
            <FooterComponent />
        </div>
    )
}